/* eslint-disable react-hooks/exhaustive-deps */
import {Button, Menu, Dropdown} from "antd"
import {Icon} from "components/Icon"
import styles from "../Contacts.module.css"
import {useTranslation} from "react-i18next"
import {UserContactType} from "types/contacts"
import {
    checkIfProfileHasPermissionsForContactsOfAnotherProfileOfType,
    checkIfProfileHasPermissionsForTheirContacts,
    formatPhoneNumberWithUSDefault,
    getFullName
} from "helpers"
import {useModel} from "hooks"
import {PermissionType} from "types/permission"
import {PopupMessageSenderV2} from "sections/NewCommunication/shared"
import {VoiceCallLink} from "components/VoiceCall"
import {DialerStudent} from "types/auto-dialer"
import {useMemo} from "react"

const roleDirectorContactLabel = {
    campusDirector: "Campus Director"
}

export function ContactCard(props) {
    const model = useModel()
    const {onClickEdit, onClickRemove, data, type, userId, profileType, showMenu = true, departmentId} = props
    const {t} = useTranslation(["user", "common"])
    data.type = type
    const renderContactIcon = () => {
        return <Icon icon={type === "personal" ? "CONTACT_FAMILY" : "PERSON_CONTACT"} color={"#939393"} />
    }

    const callTo: DialerStudent = useMemo(() => {
        if (!data.contactProfile || !data.contactProfile.phone || !departmentId) return null

        return {
            userId,
            profileId: data.contactProfile.contactProfileId,
            fullName: getFullName(data.contactProfile),
            email: data.contactProfile.email,
            phone: formatPhoneNumberWithUSDefault(data.contactProfile.phone)
        }
    }, [data, userId, departmentId])

    const menu = (
        <Menu className={styles.menuActionWrap}>
            <Menu.Item key="delete" className={styles.menuActionItem} onClick={() => onClickRemove?.(data)}>
                <Icon className={styles.menuActionIcon} icon="DELETE" />
                <span className={styles.menuActionTitle}>{t("common:action.remove")}</span>
            </Menu.Item>
            <Menu.Item key="edit" className={styles.menuActionItem} onClick={() => onClickEdit?.(data)}>
                <Icon className={styles.menuActionIcon} icon="EDIT_LINE" />
                <span className={styles.menuActionTitle}>{t("common:action.edit")}</span>
            </Menu.Item>
        </Menu>
    )

    const hasPermissionToUpdateContact =
        model.user.id === userId
            ? checkIfProfileHasPermissionsForTheirContacts(model, PermissionType.Edit)
            : checkIfProfileHasPermissionsForContactsOfAnotherProfileOfType(model, profileType, PermissionType.Edit)
    return (
        <div className={styles.cardWrap}>
            <div>
                {data.type !== UserContactType.personal && (
                    <p className={styles.cardheaderInfo__role}>{data.studentStaffContactRole.name}</p>
                )}
                {data.isEmergency === 1 && (
                    <p className={styles.cardheaderInfo__emergency}>{t("common:message.emergencyContact")}</p>
                )}
                {data.isDefault === 1 && <p className={styles.cardheaderInfo__default}>{t("user:contact.default")}</p>}
                <div className={styles.cardHeaderActionRole}>
                    <div className={styles.threedots}>
                        {/* <PopupMessageSenderV2 user={data.contactProfile} userIdField="contactUserId" /> */}
                        {roleDirectorContactLabel.campusDirector !== data.studentStaffContactRole?.name &&
                            hasPermissionToUpdateContact &&
                            showMenu && (
                                <Dropdown overlay={menu} trigger={["click"]}>
                                    <Button
                                        className={styles.iconBtn}
                                        icon={<Icon icon="MORE_VERTICAL" className={styles.moreIcon} />}
                                    />
                                </Dropdown>
                            )}
                    </div>
                </div>
            </div>

            <div className={styles.cardHeaderWrap}>
                <div className={styles.cardHeaderIcon}>{renderContactIcon()}</div>
                <div className={styles.cardHeaderInfo}>
                    <p className={styles.cardHeaderInfo__name}>
                        {data.contactProfile?.firstName} {data.contactProfile?.lastName}
                        {data.contactProfile?.title && (
                            <span className={styles.cardHeaderInfo__title}>{data.contactProfile.title}</span>
                        )}
                    </p>
                    <p className={styles.cardHeaderInfo__relation}>
                        {data.type === UserContactType.personal
                            ? data.userPersonalContactRole?.name
                            : data.studentStaffContactRole?.name}
                    </p>
                </div>
            </div>
            <div className={styles.cardBodyWrap}>
                <div className={styles.rightInfo}>
                    <VoiceCallLink callTo={callTo} departmentId={departmentId} className={styles.rightInfoItem}>
                        <Icon icon="PHONE" className={styles.rightInfoItem__icon} />
                        <p className={styles.rightInfoItem__value}>{data.contactProfile?.phone || "N/A"}</p>
                    </VoiceCallLink>
                    <div className={styles.rightInfoItem}>
                        <Icon className={styles.rightInfoItem__icon} icon="EMAIL" />
                        <p className={styles.rightInfoItem__value}>{data.contactProfile?.email || "N/A"}</p>
                    </div>
                </div>
                <div className={styles.rightInfoItem}>
                    <Icon className={styles.rightInfoItem__icon} icon="LOCATION_FILL" />
                    <p className={styles.rightInfoItem__value}>{data.contactProfile?.address || "N/A"}</p>
                </div>
            </div>
        </div>
    )
}
